import { Injectable } from '@angular/core';
import {
  SidexisToDeviceCommand,
  SidexisTriggerImageCaptureCommand,
} from '@principle-theorem/principle-bridge-core';
import {
  IBridgeDevice,
  IPatient,
} from '@principle-theorem/principle-core/interfaces';
import { DocumentReference } from '@principle-theorem/shared';
import { WithRef } from '@principle-theorem/shared';
import { BridgeCommandsService } from '../../../bridge-commands.service';

@Injectable()
export class SidexisFeatureService {
  constructor(private _bridgeCommands: BridgeCommandsService) {}

  async takeXRay(
    patient: WithRef<IPatient>,
    deviceRef: DocumentReference<IBridgeDevice>
  ): Promise<void> {
    const command: SidexisTriggerImageCaptureCommand = {
      type: SidexisToDeviceCommand.TriggerImageCapture,
      data: {
        patient,
      },
    };
    await this._bridgeCommands.sendCommand(command, deviceRef);
  }
}
